import { Card, Theme, Tooltip } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/styles";
import produitImg from "assets/icons/default_product_picture.svg";
import { Product } from "generated/graphql";
import React from "react";
import { truncateMessage } from "utils";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      borderRadius: 4,
      height: 250,
      background: "#fff",
      margin: 15,
      display: "flex",
      flexDirection: "column",
      color: "#c4c4c4",
      fontSize: 12,
      cursor: "pointer",
      "&.MuiPaper-root:hover": {
        border: `1px solid ${theme.palette.primary.main}`,
        height: 249,
      },
      width: 164,
    },
    selected: {
      borderRadius: 5,
      height: 249,
      background: "#fff",
      margin: 15,
      display: "flex",
      flexDirection: "column",
      color: "#c4c4c4",
      fontSize: 12,
      border: `1px solid ${theme.palette.primary.main}`,
      cursor: "pointer",
      width: 165,
    },
    top: {
      width: 159,
      height: 150,
      padding: 3,
    },
    bottom: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      padding: "10px",
      width: 150,
    },
    img: {
      height: "100%",
      width: "100%",
      borderRadius: 5,
    },
    titleContent: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    title: {
      fontWeight: "bold",
      color: theme.palette.primary.main,
    },
    number: {
      background: theme.palette.primary.main,
      color: "#fff",
      padding: "1px 5px",
      marginRight: -10,
      borderRadius: "5px 0 0 5px",
      height: 15,
      width: 20,
      textAlign: "center",
    },
    description: {
      fontSize: 10,
    },
    codeContent: {
      display: "flex",
      justifyContent: "space-between",
      paddingBottom: 5,
    },
    code: {
      fontWeight: 900,
    },
    price: {
      color: "#f69833",
      fontWeight: 700,
      marginRight: 5,
    },
  })
);
interface CatalogProps {
  product: Product;
  selected?: boolean;
  onItemClick: (product: Product) => void;
}

export function CatologItem({ product, onItemClick, selected = false }: CatalogProps) {
  const styles = useStyles();
  return (
    <Card className={selected ? styles.selected : styles.root} onClick={() => onItemClick(product)}>
      <div className={styles.top}>
        <img src={product.photoUrl ?? produitImg} alt="product" className={styles.img} />
      </div>
      <div className={styles.bottom}>
        <div className={styles.titleContent}>
          <Tooltip title={product.name}>
            <div className={styles.title}>{truncateMessage(product.name, 15)} </div>
          </Tooltip>
          <div className={styles.number}>{product.weight}</div>
        </div>
        <Tooltip title={product.description}>
          <div className={styles.description}>{truncateMessage(product.description, 50)}</div>
        </Tooltip>

        <div className={styles.codeContent}>
          <div className={styles.code}> {product.code} </div>
          <div className={styles.price}> {product.value} XOF </div>
        </div>
      </div>
    </Card>
  );
}
